import { render, staticRenderFns } from "./newTemplateWithAi.vue?vue&type=template&id=5b427bf0&scoped=true"
import script from "./newTemplateWithAi.vue?vue&type=script&lang=js"
export * from "./newTemplateWithAi.vue?vue&type=script&lang=js"
import style0 from "./newTemplateWithAi.vue?vue&type=style&index=0&id=5b427bf0&prod&scoped=true&lang=css"
import style1 from "./newTemplateWithAi.vue?vue&type=style&index=1&id=5b427bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b427bf0",
  null
  
)

export default component.exports